import React from 'react';
import { Link } from 'react-router-dom';
import { useTheme } from '../context/ThemeContext';
import styles from '../styles/BrutalistButton.module.css';

const BrutalistButton = ({ 
  to, 
  onClick, 
  children, 
  variant = 'default',
  className = '',
  ...props 
}) => {
  const { isDarkMode } = useTheme();
  const buttonClasses = `${styles.brutalistButton} ${styles[variant]} ${isDarkMode ? styles.dark : ''} ${className}`;

  if (to) {
    return (
      <Link 
        to={to} 
        className={buttonClasses}
        {...props}
      >
        {children}
      </Link>
    );
  }

  return (
    <button 
      onClick={onClick} 
      className={buttonClasses}
      type="button"
      {...props}
    >
      {children}
    </button>
  );
};

export default BrutalistButton;